import React, { useEffect, useState } from "react";
import { apiPath } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";
import { useParams } from "react-router-dom";

function ProductUniquePage() {
  const { productsApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(productsApi);
  const [filteredData, setFilteredData] = useState({});
  let { id } = useParams();

  // filter by slug
  useEffect(() => {
    setFilteredData(
      apiData.filter((item) => !item.slug).filter((item) => item._id === id)[0]
        ?.products
    );
  }, [apiData]);

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  const { title, image, link, description } = filteredData ?? {};

  //   // Form data
  const data = [
    {
      elementType: "file",
      label: "Product image",
      type: "Text",
      name: "image",
      defaultValue: { url: image },
      required: false,
      fullCol: true,
    },
    {
      elementType: "textField",
      label: "Product Title",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: false,
    },
    {
      elementType: "textField",
      label: "Product Description",
      type: "Text",
      name: "description",
      defaultValue: description,
      required: false,
    },
    {
      elementType: "textField",
      label: "Product URL",
      type: "Text",
      name: "link",
      defaultValue: link,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(productsApi, data, id);
  };

  return <div>{title && <GlobalForm data={data} update={update} />}</div>;
}

export default ProductUniquePage;
